export function findLastUserPromptIndex(messages: any[]): number {
    for (let i = messages.length - 1; i >= 0; i--) {
        if (messages[i].parts?.some((p: any) => p.part_kind === 'user-prompt')) {
            return i;
        }
    }
    return -1;
}

export function getFirstLine(msg: any) {
    const toolCallPart = msg.parts?.find((p: any) => p.part_kind === 'tool-call');
    if (toolCallPart) {
        const toolName = toolCallPart.tool_name || 'unknown_tool';
        const content = toolCallPart.content || '';
        const firstLineOfContent = typeof content === 'string' ? content.split('\n')[0] : '';
        return `[${toolName}] ${firstLineOfContent}`.slice(0, 120);
    }

    const firstPart = msg.parts?.[0]?.content;
    if (!firstPart) return '';

    if (Array.isArray(firstPart)) {
        const firstStringContent = firstPart.find((item) => typeof item === 'string');
        if (!firstStringContent) return '[Mixed content]';
        return firstStringContent.split('\n')[0].slice(0, 120);
    }

    if (typeof firstPart === 'string') {
        return firstPart.split('\n')[0].slice(0, 120);
    }

    return '[Unknown content type]';
}
